import React from 'react';
import { Skeleton } from 'antd';

const Loader = () => (
  <div>
    <Skeleton />
    <Skeleton />
    <Skeleton />
    <Skeleton />
    <Skeleton />
  </div>
);

export default Loader;
